export default __webpack_public_path__ + "static/media/wine_light.4c9d0f6b.png";